(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  ready(() => {
    document.documentElement.classList.add('zen-enhanced');

    const enhanceProductPage = () => {
      if (!document.body.classList.contains('template-product') || document.body.dataset.zenPdpEnhanced === 'true') return;

      const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
      const customOffer = document.querySelector('[data-zen-offer]');
      if (!productInfo && !customOffer) return;

      document.body.dataset.zenPdpEnhanced = 'true';

      const handle = window.location.pathname.split('/products/')[1]?.split(/[?#/]/)[0] || '';
      const title = (
        productInfo?.querySelector('.product__title h1, .product__title')?.textContent
        || customOffer?.querySelector('h1')?.textContent
        || document.title
        || ''
      ).trim();
      const identity = `${handle} ${title}`.toLowerCase();

      let family = 'general';
      if (/donation|give-a-box|ronald-mcdonald/.test(identity)) family = 'giving';
      else if (/bundle|pack|sampler|variety|routine|combo|assorted|discovery/.test(identity)) family = 'bundle';
      else if (/electro/.test(identity)) family = 'electrolyte';
      else if (/coffee|cafezia|poes[ií]a/.test(identity)) family = 'coffee';
      else if (/collagen/.test(identity)) family = 'collagen';
      else if (/elite-square|elite square|crispy|cacao|raspberry|cappuccino|coconut-lime/.test(identity)) family = 'square';
      else if (/protein-bar|protein bar|peanut-butter-cup|strawberry-blondie/.test(identity)) family = 'bar';

      const families = {
        bar: {
          label: 'Real-food protein bars',
          collection: '/collections/protein-bar-boxes',
          benefits: [['25 g', 'protein per package'], ['5', 'purposeful ingredients'], ['12', 'packages per box']],
          details: 'Product details & ingredients',
          related: 'Build your snack rotation'
        },
        square: {
          label: 'Crispy Elite Squares',
          collection: '/collections/elite-squares',
          benefits: [['10 g', 'protein per square'], ['12', 'essential vitamins'], ['12', 'squares per box']],
          details: 'Product details & ingredients',
          related: 'Try another flavour'
        },
        collagen: {
          label: 'Daily collagen nutrition',
          collection: '/collections/nutrition-powders',
          benefits: [['Daily', 'routine-friendly'], ['Easy', 'to mix and use'], ['Real', 'recognizable ingredients']],
          details: 'Product details & directions',
          related: 'Complete your daily routine'
        },
        electrolyte: {
          label: 'Real-fruit electrolytes',
          collection: '/collections/electrolyte-powder',
          benefits: [['4', 'essential electrolytes'], ['Real', 'fruit + sea salt'], ['Flexible', 'adjustable serving']],
          details: 'Product details & directions',
          related: 'Round out your daily routine'
        },
        coffee: {
          label: 'Purposeful coffee',
          collection: '/collections/all',
          benefits: [['340 g', 'coffee format'], ['Simple', 'daily ritual'], ['Pairs', 'with collagen']],
          details: 'Product details & preparation',
          related: 'Build a better morning'
        },
        bundle: {
          label: 'Curated value',
          collection: '/collections/bundles',
          benefits: [['More', 'variety per order'], ['One', 'easy checkout'], ['Built', 'for stocking up']],
          details: 'What is included',
          related: 'Explore more ways to stock up'
        },
        giving: {
          label: 'Nutrition with purpose',
          collection: '/collections/all',
          benefits: [['Direct', 'community support'], ['Simple', 'one-box contribution'], ['Community', 'nutrition impact']],
          details: 'How your contribution helps',
          related: 'Explore the Zentein range'
        },
        general: {
          label: 'Zentein Nutrition',
          collection: '/collections/all',
          benefits: [['Clear', 'product information'], ['$5', 'Canada-wide shipping'], ['Tracked', 'delivery']],
          details: 'Product details',
          related: 'You may also like'
        }
      };

      const familyData = families[family];
      document.body.classList.add('zen-pdp-v2', `zen-pdp--${family}`);

      const mainSection = productInfo?.closest('.shopify-section') || customOffer?.closest('.shopify-section');
      mainSection?.classList.add('zen-pdp-main');

      if (mainSection && !mainSection.querySelector('.zen-pdp-context')) {
        const context = document.createElement('div');
        context.className = 'zen-pdp-context';
        context.innerHTML = `
          <nav class="zen-pdp-breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a><span aria-hidden="true">/</span><a href="${familyData.collection}">${familyData.label}</a>
          </nav>
          <div class="zen-pdp-context__trust" aria-label="Store assurances">
            <span>$5 Canada-wide shipping</span><span>Tracked delivery</span><span>Secure checkout</span>
          </div>
        `;
        mainSection.prepend(context);
      }

      if (customOffer) {
        const offerTitle = customOffer.querySelector('.zen-offer__title');
        const offerEyebrow = customOffer.querySelector('.zen-eyebrow');
        const offerLead = customOffer.querySelector('.zen-offer__lede');
        const offerChecks = customOffer.querySelector('.zen-checks');
        const offerMeta = customOffer.querySelector('.zen-buy-meta');

        if (offerTitle && /bovine collagen with real superfoods/i.test(offerTitle.textContent || '')) {
          offerTitle.setAttribute('aria-label', offerTitle.textContent.trim());
          offerTitle.textContent = 'Bovine Collagen with Real Superfoods';
          if (offerEyebrow) offerEyebrow.textContent = 'Hydrolyzed collagen drink powder + real superfoods';
        }

        if (offerMeta && offerLead && offerChecks) {
          offerMeta.insertAdjacentElement('afterend', offerLead);
          offerLead.insertAdjacentElement('afterend', offerChecks);
        }
      }

      if (productInfo) {
        const productShell = productInfo.querySelector('.product');
        const info = productInfo.querySelector('.product__info-container');
        productShell?.classList.add('zen-pdp-product');
        info?.classList.add('zen-pdp-buy-card');

        if (info && !info.querySelector('.zen-pdp-benefit-grid')) {
          const grid = document.createElement('div');
          grid.className = 'zen-pdp-benefit-grid';
          grid.setAttribute('aria-label', 'Product highlights');
          familyData.benefits.forEach(([value, label]) => {
            const item = document.createElement('div');
            const strong = document.createElement('strong');
            const span = document.createElement('span');
            strong.textContent = value;
            span.textContent = label;
            item.append(strong, span);
            grid.append(item);
          });

          const price = info.querySelector('[id^="price-"]');
          const titleBlock = info.querySelector('.product__title');
          (price || titleBlock)?.insertAdjacentElement('afterend', grid);
        }

        const priceBlock = info?.querySelector('[id^="price-"]');
        const quantityBlock = info?.querySelector(':scope > .product-form__quantity');
        const primaryForm = info?.querySelector('product-form');
        const buyBlock = primaryForm?.parentElement;
        if (priceBlock && quantityBlock && buyBlock?.parentElement === info) {
          priceBlock.insertAdjacentElement('afterend', quantityBlock);
          quantityBlock.insertAdjacentElement('afterend', buyBlock);
        }

        const couponBlock = buyBlock?.querySelector('[id^="coupon-body-"]');
        if (couponBlock && primaryForm) primaryForm.insertAdjacentElement('afterend', couponBlock);

        const description = info?.querySelector(':scope > .product__description');
        if (description && !description.closest('.zen-pdp-disclosure')) {
          const details = document.createElement('details');
          details.className = 'zen-pdp-disclosure';
          const summary = document.createElement('summary');
          const label = document.createElement('span');
          const icon = document.createElement('span');
          label.textContent = familyData.details;
          icon.className = 'zen-pdp-disclosure__icon';
          icon.setAttribute('aria-hidden', 'true');
          summary.append(label, icon);
          description.before(details);
          details.append(summary, description);
        }

        const buyButtons = info?.querySelector('product-form, .product-form');
        if (buyButtons && !info.querySelector('.zen-pdp-assurance')) {
          const assurance = document.createElement('div');
          assurance.className = 'zen-pdp-assurance';
          assurance.innerHTML = '<span>Freshly packed</span><span>Secure checkout</span><span>Tracked shipping</span>';
          buyButtons.insertAdjacentElement('afterend', assurance);
        }

        if (buyButtons?.parentElement) {
          const purchaseContainer = buyButtons.parentElement;
          const placeCouponAfterButton = () => {
            const coupon = purchaseContainer.querySelector('[id^="coupon-body-"]');
            const assurance = purchaseContainer.querySelector('.zen-pdp-assurance');
            const anchor = assurance || buyButtons;
            if (coupon && anchor.nextElementSibling !== coupon) anchor.insertAdjacentElement('afterend', coupon);
          };
          placeCouponAfterButton();
          const purchaseObserver = new MutationObserver(placeCouponAfterButton);
          purchaseObserver.observe(purchaseContainer, { childList: true, subtree: true });
          window.setTimeout(() => purchaseObserver.disconnect(), 10000);
        }

        const inlineReview = [...(info?.children || [])].find((element) =>
          element.id?.includes('judge_me_reviews_review_snippet_widget')
        );
        if (inlineReview && mainSection && !document.querySelector('.zen-pdp-inline-reviews')) {
          const reviewSection = document.createElement('section');
          reviewSection.className = 'zen-pdp-inline-reviews';
          reviewSection.setAttribute('aria-label', 'Customer reviews');
          reviewSection.innerHTML = '<div class="zen-pdp-inline-reviews__heading"><span>Real customer experiences</span><h2>What customers say after the first bite.</h2></div>';
          reviewSection.append(inlineReview);
          mainSection.insertAdjacentElement('afterend', reviewSection);
        }
      }

      const createStoryHeader = (eyebrow, heading, body) => {
        const header = document.createElement('header');
        header.className = 'zen-pdp-story__heading';
        const eyebrowElement = document.createElement('span');
        const headingElement = document.createElement('h2');
        eyebrowElement.textContent = eyebrow;
        headingElement.textContent = heading;
        header.append(eyebrowElement, headingElement);
        if (body) {
          const bodyElement = document.createElement('p');
          bodyElement.textContent = body;
          header.append(bodyElement);
        }
        return header;
      };

      const overviewIntros = {
        bar: 'Real-food ingredients, 25 g of protein, and a format built for busy days.',
        square: 'Crispy texture, 10 g of protein, and whole-food nutrition in every square.',
        collagen: 'Daily collagen nutrition designed to mix easily into the routines you already enjoy.',
        electrolyte: 'Real fruit, sea salt, and flexible serving strength for hydration that fits your day.',
        coffee: 'Origin, flavour, and a brewing format made for a better morning.',
        bundle: 'A curated mix of Zentein favourites for convenient routines, variety, and stocking up.',
        giving: 'Turn a simple purchase into practical nourishment for a community organization.',
        general: 'Purposeful nutrition made with recognizable ingredients and practical daily routines in mind.'
      };

      if (productInfo && mainSection && !document.querySelector('.zen-pdp-overview')) {
        const descriptionSource = productInfo.querySelector('.zen-pdp-disclosure .product__description, .product__description');
        if ((descriptionSource?.textContent || '').trim().length > 80) {
          const overview = document.createElement('section');
          overview.className = 'shopify-section zen-pdp-story-section zen-pdp-overview';
          overview.id = 'zen-pdp-overview';

          const shell = document.createElement('div');
          shell.className = 'zen-pdp-story__shell zen-pdp-overview__shell';
          shell.append(createStoryHeader('Product overview', 'Everything you need to know.', overviewIntros[family]));

          const content = document.createElement('div');
          content.className = 'zen-pdp-overview__content';
          content.innerHTML = descriptionSource.innerHTML;
          content.querySelectorAll('meta, script, style').forEach((element) => element.remove());
          shell.append(content);
          overview.append(shell);

          const overviewAnchor = document.querySelector('.zen-pdp-inline-reviews') || mainSection;
          overviewAnchor.insertAdjacentElement('afterend', overview);
        }
      }

      const featureSections = [...document.querySelectorAll('#MainContent > .shopify-section.feature-type1')];
      if (featureSections.length) {
        const featureItems = featureSections.flatMap((section) => [...section.querySelectorAll('.wrapper-box > .box')])
          .map((item) => ({
            image: item.querySelector('.box__image img')?.cloneNode(false),
            title: item.querySelector('.box__title')?.textContent.trim() || '',
            description: item.querySelector('.box__description')?.innerHTML || ''
          }))
          .filter((item) => item.title);

        if (featureItems.length) {
          const featureSection = featureSections[0];
          featureSection.classList.remove('feature-type1');
          featureSection.classList.add('zen-pdp-story-section', 'zen-pdp-proof-section');
          featureSection.innerHTML = '';

          const shell = document.createElement('div');
          shell.className = 'zen-pdp-story__shell';
          shell.append(createStoryHeader('Why Zentein', 'Purpose in every detail.', 'Real ingredients, purposeful nutrition, and practical details behind every bite.'));

          const grid = document.createElement('div');
          grid.className = 'zen-pdp-proof-grid';
          featureItems.forEach((item) => {
            const card = document.createElement('article');
            card.className = 'zen-pdp-proof-card';
            if (item.image) {
              item.image.alt = item.image.alt || item.title;
              item.image.loading = 'lazy';
              const media = document.createElement('div');
              media.className = 'zen-pdp-proof-card__media';
              media.append(item.image);
              card.append(media);
            }
            const copy = document.createElement('div');
            const titleElement = document.createElement('h3');
            titleElement.textContent = item.title;
            copy.append(titleElement);
            if (item.description) {
              const descriptionElement = document.createElement('div');
              descriptionElement.className = 'zen-pdp-proof-card__description';
              descriptionElement.innerHTML = item.description;
              copy.append(descriptionElement);
            }
            card.append(copy);
            grid.append(card);
          });
          shell.append(grid);
          featureSection.append(shell);
          featureSections.slice(1).forEach((section) => section.remove());
        }
      }

      const getFlipCardRoots = (section) => [...section.querySelectorAll('div')].filter((element) =>
        [...element.classList].some((className) => className.startsWith('flip-card-template--'))
        && element.querySelector(':scope > [class*="flip-card-wrapper-"]')
      );

      const dedupeInformationCards = (cards) => {
        const seen = new Set();
        return cards.filter((card) => {
          const key = card.title.toLowerCase().replace(/\s+/g, ' ').trim();
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      };

      const createInformationCard = ({ image, index, title: cardTitle, summary, details }) => {
        const card = document.createElement('article');
        card.className = 'zen-pdp-info-card';
        if (image) {
          image.alt = image.alt || cardTitle;
          image.loading = 'lazy';
          const media = document.createElement('div');
          media.className = 'zen-pdp-info-card__media';
          media.append(image);
          const number = document.createElement('span');
          number.textContent = String(index + 1).padStart(2, '0');
          media.append(number);
          card.append(media);
        }

        const body = document.createElement('div');
        body.className = 'zen-pdp-info-card__body';
        const titleElement = document.createElement('h3');
        titleElement.textContent = cardTitle.replace(/^\d+\.\s*/, '');
        body.append(titleElement);
        if (summary) {
          const summaryElement = document.createElement('div');
          summaryElement.className = 'zen-pdp-info-card__summary';
          summaryElement.innerHTML = summary;
          body.append(summaryElement);
        }
        if (details) {
          const disclosure = document.createElement('details');
          disclosure.className = 'zen-pdp-info-card__details';
          const disclosureSummary = document.createElement('summary');
          disclosureSummary.innerHTML = '<span>Why it is here</span><span aria-hidden="true">+</span>';
          const disclosureBody = document.createElement('div');
          disclosureBody.innerHTML = details;
          disclosure.append(disclosureSummary, disclosureBody);
          body.append(disclosure);
        }
        card.append(body);
        return card;
      };

      document.querySelectorAll('#MainContent > .shopify-section[id*="__ss_flip_cards_2_"]').forEach((section) => {
        const headingSource = section.querySelector('[class*="flip-card-heading-"]');
        const cardData = dedupeInformationCards(getFlipCardRoots(section).map((card) => {
          const front = card.querySelector('[class*="flip-card-front-"]');
          const back = card.querySelector('[class*="flip-card-back-"]');
          const paragraphs = [...(back?.querySelectorAll('[class*="flip-text-"]') || [])];
          return {
            image: front?.querySelector('img')?.cloneNode(false),
            title: front?.querySelector('[class*="flip-title-"]')?.textContent.trim() || '',
            summary: paragraphs[0]?.innerHTML || '',
            details: paragraphs[1]?.innerHTML || ''
          };
        }).filter((card) => card.title));

        if (!cardData.length) return;
        const headingText = headingSource?.textContent.trim().replace(/\s+/g, ' ')
          || (family === 'square' ? 'The functional ingredients in every square' : 'A closer look at what is inside');
        section.classList.add('zen-pdp-story-section', 'zen-pdp-ingredient-section');
        section.innerHTML = '';

        const shell = document.createElement('div');
        shell.className = 'zen-pdp-story__shell';
        shell.append(createStoryHeader('Ingredient story', headingText, 'See what each ingredient brings to the recipe, from flavour and texture to functional nutrition.'));
        const grid = document.createElement('div');
        grid.className = 'zen-pdp-info-grid';
        cardData.forEach((card, index) => grid.append(createInformationCard({ ...card, index })));
        shell.append(grid);
        section.append(shell);
      });

      document.querySelectorAll('#MainContent > .shopify-section[id*="__ss_flip_cards_"]:not([id*="__ss_flip_cards_2_"])').forEach((section) => {
        const cardData = dedupeInformationCards(getFlipCardRoots(section).map((card) => {
          const front = card.querySelector('[class*="flip-card-front-"]');
          const back = card.querySelector('[class*="flip-card-back-"]');
          const detailsElement = back?.querySelector('[class*="flip-text-"]');
          const detailsHtml = detailsElement?.innerHTML || '';
          const detailsText = (detailsElement?.textContent || '').trim();
          return {
            image: front?.querySelector('img')?.cloneNode(false),
            title: front?.querySelector('[class*="flip-title-"]')?.textContent.trim() || '',
            summary: detailsText ? `<p>${detailsText.slice(0, 138)}${detailsText.length > 138 ? '…' : ''}</p>` : '',
            details: detailsHtml
          };
        }).filter((card) => card.title));

        if (!cardData.length) return;
        section.classList.add('zen-pdp-story-section', 'zen-pdp-nutrient-section');
        section.innerHTML = '';
        const shell = document.createElement('div');
        shell.className = 'zen-pdp-story__shell';
        shell.append(createStoryHeader('Whole-food micronutrients', family === 'square' ? 'The food sources behind the vitamin blend.' : 'A closer look at the blend.', 'Each source plays a role in the whole-food vitamin and mineral blend.'));
        const grid = document.createElement('div');
        grid.className = 'zen-pdp-info-grid zen-pdp-info-grid--compact';
        cardData.forEach((card, index) => grid.append(createInformationCard({ ...card, index })));
        shell.append(grid);
        section.append(shell);
      });

      document.querySelectorAll('#MainContent > .shopify-section[id*="__ss_collection_tabs_2_"]').forEach((section) => {
        const titleSource = section.querySelector('[class*="flexible-title-"]');
        const textSource = section.querySelector('[class*="flexible-text-template-"]');
        const sectionImage = section.querySelector('[class*="flexible-image-"] img');
        const sectionImageSource = sectionImage?.currentSrc || sectionImage?.src || '';
        const productImage = mainSection?.querySelector('.product__media img, .product__media-list img');
        const imageSource = /pure-white-background/i.test(sectionImageSource) ? productImage : sectionImage;
        const image = imageSource?.cloneNode(false);
        const title = titleSource?.textContent.trim() || '';
        const content = textSource?.innerHTML || '';
        if (!title || !content) return;

        section.classList.add('zen-pdp-story-section', 'zen-pdp-format-section');
        section.innerHTML = '';

        const shell = document.createElement('div');
        shell.className = 'zen-pdp-story__shell zen-pdp-format__shell';
        const media = document.createElement('div');
        media.className = 'zen-pdp-format__media';
        if (image) {
          image.alt = image.alt || title;
          image.loading = 'lazy';
          media.append(image);
        }
        const note = document.createElement('p');
        note.innerHTML = '<span>What agglomerated means</span>Faster dissolving, less clumping, and more even blending.';
        media.append(note);

        const copy = document.createElement('div');
        copy.className = 'zen-pdp-format__copy';
        copy.append(createStoryHeader('Best in class', title, 'Why the format and sourcing matter in a daily collagen routine.'));
        const body = document.createElement('div');
        body.className = 'zen-pdp-format__body';
        body.innerHTML = content;
        copy.append(body);
        shell.append(media, copy);
        section.append(shell);
      });

      document.querySelectorAll('#MainContent > .shopify-section[id*="__ss_tabs_icon_image_"]').forEach((section) => {
        const faqRoots = [...section.querySelectorAll('div')].filter((element) =>
          [...element.classList].some((className) => className.startsWith('faq-template--'))
          && ![...element.classList].some((className) => className.startsWith('faq-answer-height-cal-'))
        );
        const faqData = faqRoots.map((faq) => {
          const button = faq.querySelector(':scope > [class*="button-template-"]');
          const answer = faq.querySelector(':scope > [class*="answer-template-"]');
          return {
            image: button?.querySelector('img')?.cloneNode(false),
            question: (button?.textContent || '').trim().replace(/\s+/g, ' '),
            answer: answer?.innerHTML || ''
          };
        }).filter((faq) => faq.question && faq.answer);

        if (!faqData.length) return;
        const title = section.querySelector('[class*="title-template-"]')?.textContent.trim() || 'Frequently asked questions';
        const faqImages = [...section.querySelectorAll('img')];
        const mainImage = faqImages.find((image) => !faqRoots.some((root) => root.contains(image)))?.cloneNode(false);
        section.classList.add('zen-pdp-story-section', 'zen-pdp-faq-section');
        section.innerHTML = '';

        const shell = document.createElement('div');
        shell.className = 'zen-pdp-story__shell zen-pdp-faq__shell';
        const intro = document.createElement('div');
        intro.className = 'zen-pdp-faq__intro';
        intro.append(createStoryHeader('Good to know', title, 'Clear answers to the questions customers ask most often.'));
        if (mainImage) {
          mainImage.alt = mainImage.alt || title;
          mainImage.loading = 'lazy';
          const media = document.createElement('div');
          media.className = 'zen-pdp-faq__media';
          media.append(mainImage);
          intro.append(media);
        }

        const list = document.createElement('div');
        list.className = 'zen-pdp-faq__list';
        faqData.forEach((faq, index) => {
          const item = document.createElement('details');
          item.className = 'zen-pdp-faq__item';
          if (index === 0) item.open = true;
          const summary = document.createElement('summary');
          if (faq.image) {
            faq.image.alt = '';
            faq.image.loading = 'lazy';
            summary.append(faq.image);
          }
          const question = document.createElement('span');
          question.textContent = faq.question;
          const icon = document.createElement('span');
          icon.className = 'zen-pdp-faq__icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = '+';
          summary.append(question, icon);
          const answer = document.createElement('div');
          answer.className = 'zen-pdp-faq__answer';
          answer.innerHTML = faq.answer;
          item.append(summary, answer);
          list.append(item);
        });
        shell.append(intro, list);
        section.append(shell);
      });

      document.querySelectorAll('#MainContent > .shopify-section[id*="__ss_comparison_table_2_"]').forEach((section) => {
        const originalHeading = section.querySelector('[class*="product-other-heading-"]')?.textContent.trim()
          || 'Compare the ingredient standards';
        const originalRows = [...section.querySelectorAll('[class*="product-other-grid-"]')];
        if (originalRows.length < 2) return;

        const headerCells = [...originalRows[0].children].slice(1)
          .map((cell) => cell.textContent.trim())
          .filter(Boolean);
        const rows = originalRows.slice(1).map((row) => {
          const cells = [...row.children];
          return {
            label: cells[0]?.textContent.trim() || '',
            values: cells.slice(1).map((cell) => {
              const icon = cell.querySelector('[class*="product-other-icon-"]');
              const classes = icon?.className || '';
              if (/icon-yes-/i.test(classes)) return 'yes';
              if (/icon-no-/i.test(classes)) return 'no';
              return 'unknown';
            })
          };
        }).filter((row) => row.label);
        if (!headerCells.length || !rows.length) return;

        section.classList.add('zen-pdp-story-section', 'zen-pdp-comparison-section');
        section.innerHTML = '';
        const shell = document.createElement('div');
        shell.className = 'zen-pdp-story__shell zen-pdp-comparison__shell';
        shell.append(createStoryHeader('Ingredient standards', originalHeading, 'See how Zentein’s ingredient standards compare with common protein-snack formulations.'));

        const legend = document.createElement('div');
        legend.className = 'zen-pdp-comparison__legend';
        legend.innerHTML = '<span><i aria-hidden="true">×</i> Not used</span><span><i aria-hidden="true">✓</i> Listed</span><span><i aria-hidden="true">?</i> Not clear</span>';

        const tableWrap = document.createElement('div');
        tableWrap.className = 'zen-pdp-comparison__table-wrap';
        tableWrap.setAttribute('tabindex', '0');
        tableWrap.setAttribute('role', 'region');
        tableWrap.setAttribute('aria-label', 'Scrollable ingredient comparison');
        const table = document.createElement('table');
        table.className = 'zen-pdp-comparison__table';
        const thead = document.createElement('thead');
        const headerRow = document.createElement('tr');
        const ingredientHeading = document.createElement('th');
        ingredientHeading.scope = 'col';
        ingredientHeading.textContent = 'Ingredient or additive';
        headerRow.append(ingredientHeading);
        headerCells.forEach((label, index) => {
          const cell = document.createElement('th');
          cell.scope = 'col';
          cell.textContent = label;
          if (index === 0) cell.className = 'zen-pdp-comparison__zentein';
          headerRow.append(cell);
        });
        thead.append(headerRow);

        const tbody = document.createElement('tbody');
        const symbols = { yes: '✓', no: '×', unknown: '?' };
        const labels = { yes: 'Listed', no: 'Not used', unknown: 'Not clear' };
        rows.forEach((row) => {
          const tableRow = document.createElement('tr');
          const label = document.createElement('th');
          label.scope = 'row';
          label.textContent = row.label;
          tableRow.append(label);
          row.values.forEach((value, index) => {
            const cell = document.createElement('td');
            cell.className = `zen-pdp-comparison__status zen-pdp-comparison__status--${value}${index === 0 ? ' zen-pdp-comparison__zentein' : ''}`;
            const symbol = document.createElement('span');
            symbol.setAttribute('aria-label', labels[value]);
            symbol.textContent = symbols[value];
            cell.append(symbol);
            tableRow.append(cell);
          });
          tbody.append(tableRow);
        });
        table.append(thead, tbody);
        tableWrap.append(table);
        shell.append(legend, tableWrap);
        section.append(shell);
      });

      const fullReviewSection = [...document.querySelectorAll('#MainContent > .shopify-section')]
        .find((section) => section.querySelector('.jdgm-rev-widg'));
      fullReviewSection?.classList.add('zen-pdp-full-reviews');

      const pairingSection = document.querySelector('.zen-pdp-pairings-section')?.closest('.shopify-section')
        || document.querySelector('.zen-pdp-pairings')?.closest('.shopify-section');
      if (pairingSection && fullReviewSection && pairingSection !== fullReviewSection) {
        fullReviewSection.insertAdjacentElement('beforebegin', pairingSection);
      }

      const relatedHeading = document.querySelector('.related-products__heading');
      if (relatedHeading) relatedHeading.textContent = familyData.related;

      const sectionMatches = [
        { label: 'Ingredients', pattern: /ingredients|what.?s inside|anatomy/i },
        { label: 'Nutrition', pattern: /nutrition|protein per|nutrition facts/i },
        { label: 'How to use', pattern: /how to use|directions|routine|ways to use/i },
        { label: 'Reviews', pattern: /customer reviews|let customers speak|reviews/i },
        { label: 'FAQ', pattern: /frequently asked|\bfaq\b/i }
      ];
      const contentSections = [...document.querySelectorAll('#MainContent > .shopify-section')]
        .filter((section) => section !== mainSection && !section.classList.contains('zen-pdp-inline-reviews'));
      const links = [];

      sectionMatches.forEach(({ label, pattern }) => {
        const section = contentSections.find((candidate) => pattern.test(candidate.textContent || ''));
        if (!section || links.some((item) => item.section === section)) return;
        if (!section.id) section.id = `zen-pdp-${label.toLowerCase().replace(/[^a-z]+/g, '-')}`;
        links.push({ label, section });
      });

      if (links.length >= 2 && mainSection && !document.querySelector('.zen-pdp-jump')) {
        const jump = document.createElement('nav');
        jump.className = 'zen-pdp-jump';
        jump.setAttribute('aria-label', 'Product information');
        const inner = document.createElement('div');
        inner.className = 'zen-pdp-jump__inner';
        const lead = document.createElement('span');
        lead.textContent = 'Explore';
        inner.append(lead);
        links.slice(0, 5).forEach(({ label, section }) => {
          const link = document.createElement('a');
          link.href = `#${section.id}`;
          link.textContent = label;
          link.addEventListener('click', (event) => {
            event.preventDefault();
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          inner.append(link);
        });
        jump.append(inner);
        const reviews = document.querySelector('.zen-pdp-inline-reviews');
        (reviews || mainSection).insertAdjacentElement('afterend', jump);
      }
    };

    enhanceProductPage();

    const editorialPage = document.body.matches('.template-page, .template-blog, .template-article');
    if (editorialPage) {
      const slugify = (value) => value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

      document.querySelectorAll('#MainContent h2, #MainContent h3').forEach((heading) => {
        const slug = slugify(heading.textContent || '');
        if (!slug || document.getElementById(slug)) return;
        const anchor = document.createElement('span');
        anchor.id = slug;
        anchor.className = 'zen-anchor';
        anchor.setAttribute('aria-hidden', 'true');
        heading.before(anchor);
      });

      const blogGrid = document.querySelector('.template-blog .main-blog');
      if (blogGrid && !document.getElementById('zen-articles')) blogGrid.id = 'zen-articles';
    }

    document.querySelectorAll('[data-zen-offer]').forEach((offer) => {
      const quantityInput = offer.querySelector('[data-zen-quantity]');
      const tiers = [...offer.querySelectorAll('[data-zen-tier]')];
      const submit = offer.querySelector('[data-zen-submit]');
      const sticky = document.querySelector('[data-zen-sticky-buy]');
      const planInput = offer.querySelector('[data-zen-selling-plan]');
      const purchaseOptions = [...offer.querySelectorAll('[data-zen-purchase-option]')];
      const price = offer.querySelector('.zen-price');

      const setQuantity = (value) => {
        const quantity = Math.max(1, Number.parseInt(value, 10) || 1);
        if (quantityInput) {
          quantityInput.value = String(quantity);
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        tiers.forEach((tier) => {
          const active = Number.parseInt(tier.dataset.zenTier, 10) === quantity;
          tier.classList.toggle('is-selected', active);
          tier.setAttribute('aria-pressed', String(active));
        });
        if (submit && !submit.disabled) {
          submit.textContent = quantity === 1
            ? submit.dataset.zenSingleLabel
            : `Add ${quantity} bags to cart`;
        }
        const stickyButton = sticky?.querySelector('button');
        if (stickyButton) stickyButton.textContent = quantity === 1 ? 'Add to cart' : `Add ${quantity} bags to cart`;
      };

      tiers.forEach((tier) => tier.addEventListener('click', () => setQuantity(tier.dataset.zenTier)));
      setQuantity(quantityInput?.value || 1);

      const setPurchaseOption = (option) => {
        if (!option) return;
        purchaseOptions.forEach((item) => {
          item.closest('.zen-purchase-option')?.classList.toggle('is-selected', item === option);
        });
        if (planInput) {
          planInput.value = option.value;
          planInput.disabled = !option.value;
        }
        if (price && option.dataset.zenPlanPrice) price.textContent = option.dataset.zenPlanPrice;
        if (submit && option.dataset.zenPlanPrice) {
          submit.dataset.zenSingleLabel = `Add to cart • ${option.dataset.zenPlanPrice}`;
        }
        setQuantity(quantityInput?.value || 1);
      };

      purchaseOptions.forEach((option) => option.addEventListener('change', () => setPurchaseOption(option)));
      setPurchaseOption(purchaseOptions.find((option) => option.checked));

      offer.querySelectorAll('[data-zen-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const image = offer.querySelector('.zen-gallery__main img');
          if (!image || !thumb.dataset.zenImage) return;
          image.src = thumb.dataset.zenImage;
          image.srcset = '';
          image.alt = thumb.dataset.zenAlt || image.alt;
          offer.querySelectorAll('[data-zen-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      if (sticky && submit) {
        sticky.querySelector('button')?.addEventListener('click', () => submit.click());
        const observer = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0.2 });
        observer.observe(submit);
      }
    });

    document.querySelectorAll('a[href^="#zen-"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const addCartSavings = () => {
      if (document.querySelector('[data-zcart]')) return;
      const targets = [
        document.querySelector('.cart-drawer .drawer__footer'),
        document.querySelector('.template-cart .cart__footer')
      ].filter(Boolean);
      targets.forEach((target) => {
        if (target.querySelector('.zen-cart-savings')) return;
        target.insertAdjacentHTML('afterbegin', `
          <div class="zen-cart-savings">
            <strong>Automatic quantity savings</strong>
            <span>Buy 2: save 5% &nbsp;•&nbsp; Buy 3: save 10% &nbsp;•&nbsp; Buy 5: save 15%</span>
          </div>
        `);
      });
    };
    addCartSavings();
    let cartSavingsQueued = false;
    new MutationObserver(() => {
      if (cartSavingsQueued) return;
      cartSavingsQueued = true;
      window.requestAnimationFrame(() => {
        addCartSavings();
        cartSavingsQueued = false;
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll('[data-zen-tabs]').forEach((tabSet) => {
      const tabs = [...tabSet.querySelectorAll('[data-zen-tab]')];
      const panels = [...tabSet.querySelectorAll('[data-zen-panel]')];
      if (!tabs.length || !panels.length) return;

      const activate = (name, focus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.zenTab === name;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach((panel) => {
          const active = panel.dataset.zenPanel === name;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.zenTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
          event.preventDefault();
          const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
          const next = (index + direction + tabs.length) % tabs.length;
          activate(tabs[next].dataset.zenTab, true);
        });
      });
    });

    document.querySelectorAll('[data-zen-scroll-row]').forEach((row) => {
      const section = row.closest('section');
      section?.querySelector('[data-zen-scroll-prev]')?.addEventListener('click', () => {
        row.scrollBy({ left: -Math.max(row.clientWidth * 0.78, 280), behavior: 'smooth' });
      });
      section?.querySelector('[data-zen-scroll-next]')?.addEventListener('click', () => {
        row.scrollBy({ left: Math.max(row.clientWidth * 0.78, 280), behavior: 'smooth' });
      });
    });

    document.querySelectorAll('[data-zen-accordion-cards]').forEach((group) => {
      group.querySelectorAll('details').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          group.querySelectorAll('details').forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    });

    const library = document.querySelector('[data-zen-library]');
    if (library) {
      const search = library.querySelector('[data-zen-library-search]');
      const filters = [...library.querySelectorAll('[data-zen-library-filter]')];
      const items = [...library.querySelectorAll('[data-zen-library-item]')];
      const empty = library.querySelector('[data-zen-library-empty]');
      let activeFilter = 'all';

      const applyLibraryFilters = () => {
        const query = (search?.value || '').trim().toLowerCase();
        let visible = 0;
        items.forEach((item) => {
          const haystack = item.dataset.search || '';
          const matchesText = !query || haystack.includes(query);
          const matchesTopic = activeFilter === 'all' || haystack.includes(activeFilter);
          const show = matchesText && matchesTopic;
          item.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      };

      search?.addEventListener('input', applyLibraryFilters);
      filters.forEach((filter) => filter.addEventListener('click', () => {
        activeFilter = filter.dataset.zenLibraryFilter || 'all';
        filters.forEach((button) => {
          const active = button === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        applyLibraryFilters();
      }));
    }

    const glossary = document.querySelector('[data-zen-glossary]');
    if (glossary) {
      const search = glossary.querySelector('[data-zen-glossary-search]');
      const filters = [...glossary.querySelectorAll('[data-zen-glossary-filter]')];
      const items = [...glossary.querySelectorAll('[data-zen-glossary-item]')];
      const empty = glossary.querySelector('[data-zen-glossary-empty]');
      let activeFilter = 'all';

      const applyGlossaryFilters = () => {
        const query = (search?.value || '').trim().toLowerCase();
        let visible = 0;
        items.forEach((item) => {
          const haystack = `${item.dataset.search || ''} ${item.textContent || ''}`.toLowerCase();
          const categories = (item.dataset.category || '').split(' ');
          const show = (!query || haystack.includes(query)) && (activeFilter === 'all' || categories.includes(activeFilter));
          item.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      };

      search?.addEventListener('input', applyGlossaryFilters);
      filters.forEach((filter) => filter.addEventListener('click', () => {
        activeFilter = filter.dataset.zenGlossaryFilter || 'all';
        filters.forEach((button) => {
          const active = button === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        applyGlossaryFilters();
      }));
    }

    const articleRoot = document.querySelector('[data-zen-article]');
    if (articleRoot) {
      const content = articleRoot.querySelector('[data-zen-article-content]');
      const tocLinks = articleRoot.querySelector('[data-zen-toc-links]');
      const progress = articleRoot.querySelector('[data-zen-read-progress]');
      const headings = [...(content?.querySelectorAll('h2, h3') || [])];
      const usedIds = new Set();

      headings.forEach((heading, index) => {
        const base = (heading.id || heading.textContent || `section-${index + 1}`)
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '') || `section-${index + 1}`;
        let id = base;
        let suffix = 2;
        while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
          id = `${base}-${suffix}`;
          suffix += 1;
        }
        usedIds.add(id);
        heading.id = id;
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent || '';
        if (heading.tagName === 'H3') link.style.paddingLeft = '10px';
        tocLinks?.append(link);
      });

      const updateReadingProgress = () => {
        if (!content || !progress) return;
        const start = content.offsetTop - window.innerHeight * 0.25;
        const distance = Math.max(content.offsetHeight - window.innerHeight * 0.5, 1);
        const percent = Math.min(100, Math.max(0, ((window.scrollY - start) / distance) * 100));
        progress.style.width = `${percent}%`;
      };
      updateReadingProgress();
      window.addEventListener('scroll', updateReadingProgress, { passive: true });
      window.addEventListener('resize', updateReadingProgress);
    }
  });
})();
